import script from "./wordShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./wordShow.vue?vue&type=script&setup=true&lang=ts"

import "./wordShow.vue?vue&type=style&index=0&id=dc0af53a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc0af53a"]])

export default __exports__